import React, { useState, createContext } from "react";
import { IntlProvider } from "react-intl";

import Turkish from "../lang/tr.json";
import English from "../lang/en.json";

// Define types for our messages
type Messages = Record<string, string>;

// Define the context type
interface ContextType {
  locale: string;
  selectLanguage: (newLocale: string) => void;
}

// Create context with default values
export const Context = createContext<ContextType>({
  locale: "en",
  selectLanguage: (newLocale: string) => {},
});

// Get browser language
const local = navigator.language;

// Set default language based on browser language
let lang: Messages;
if (local === "tr") {
  lang = Turkish;
} else {
  lang = English;
}

// Define props without using React.FC
interface WrapperProps {
  children: React.ReactNode;
}

// Use regular function declaration without React.FC
const Wrapper = ({ children }: WrapperProps) => {
  const [locale, setLocale] = useState<string>(local);
  const [messages, setMessages] = useState<Messages>(lang);

  function selectLanguage(newLocale: string): void {
    setLocale(newLocale);
    if (newLocale === "en") {
      setMessages(English);
    } else {
      setMessages(Turkish);
    }
  }

  return (
    <Context.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={messages} locale={locale}>
        {children as any}
      </IntlProvider>
    </Context.Provider>
  );
};

export default Wrapper;
